import * as React from 'react';
import Utils from '../../../helpers/utils';
import { isMobile } from 'react-device-detect';

const ContentTitle = (props) => {
    let containerId = null != props && props.bluebg == true ? "header-custom-title-2" : "header-custom-title";
    let headerTextStyle = buildHeaderTextStyle();

    function buildHeaderTextStyle() {
        let style = { color: 'black' };

        if (isMobile) {
            style = { ...style, fontSize: 26 }; // default is 30px
        }

        return style;
    }

    function handleActiveMenu(){        
        Utils.activeMenu(props.active);
        Utils.updateScreenTitle(props.title);
    }

    return (
        <div className="content">
            {handleActiveMenu()}
            <div className="main-header">
                <div className="main-header" id={containerId}>
                    <h2 className="header-custom-title inline-block" style={headerTextStyle}>{props.title}</h2>
                    {props.children}
                    <div className="header-hr" style={{width:"100%",height:"5px",backgroundColor:"black",marginTop:"15px"}}></div>
                </div>
            </div>
        </div>
    )
}

export default ContentTitle;


// WEBPACK FOOTER //
// ./components/common/container/title.jsx